<template>
    <div class="grid grid-cols-3 gap-4 p-4 bg-gray-50">
        <div v-if="isStaff" class="space-y-4">
            <order-journal-card :order="row" />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import OrderJournalCard from '@/components/cards/OrderJournalCard.vue';

const props = defineProps({
    row:
    {
        type:     Object,
        required: true,
    },
});

const store = useStore();
const isStaff = computed(() => store.getters['account/isStaff']);
</script>
